import { connect } from 'react-redux'
import NumbersAvailableTable from './NumbersAvailableTable'
import { getAvailableNumbers } from '../Numbers.actions'

const stateToProps = ({ numbers: { available } }, { country, type, formData }) => {
  const { filter } = formData
  const cacheKey = JSON.stringify([country, type, filter])
  return {
    availableNumbers: available[cacheKey] || {},
    country,
    type,
    filter,
    cacheKey,
  }
}

const dispatchToProps = {
  getAvailableNumbers,
}

export default connect(stateToProps, dispatchToProps)(NumbersAvailableTable)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersAvailableTable/NumbersAvailableTable.container.js